import bolide_assistant_composer from "./BolideAssistantComposer/BolideAssistantComposer.vue";
import bolide_assistant_header from "./BolideAssistantHeader/BolideAssistantHeader.vue";
import bolide_assistant_history from "./BolideAssistantHistory/BolideAssistantHistory.vue";
import bolide_assistant_messages from "./BolideAssistantMessages/BolideAssistantMessages.vue";
import chat_methods from "./bolide_assistant_chat_methods";
import conversation_methods from "./bolide_assistant_conversation_methods";
import query_methods from "./bolide_assistant_query_methods";

export default {
  name: "BolideAssistant",

  components: {
    BolideAssistantComposer: bolide_assistant_composer,
    BolideAssistantHeader: bolide_assistant_header,
    BolideAssistantHistory: bolide_assistant_history,
    BolideAssistantMessages: bolide_assistant_messages,
  },

  props: {
    is_open: Boolean,
    scope: {
      type: Object,
      default: null,
    },
    compare_property_options: {
      type: Array,
      default: () => [],
    },
    compare_property_ids: {
      type: Array,
      default: () => [],
    },
    standalone: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["close-assistant", "update:compare_property_ids"],

  data() {
    return ({
      active_storage_key: "bolide_assist_active_conversation_v1",
      is_fullscreen: false,
      is_history_open: true,
      user_message: "",
      is_sending: false,
      typewriter_timer: null,
      conversations: [],
      active_conversation_id: null,
      chat_history_next_cursor: null,
      is_loading_chat_history: false,
      has_loaded_backend_history: false,
      chat_history_load_error: "",
      should_start_new_after_history_load: false,
    });
  },

  computed: {
    active_conversation() {
      return this.conversations.find(
        (item) => item.id === this.active_conversation_id
      ) || null;
    },

    active_conversation_title() {
      return this.active_conversation
        ? this.get_conversation_title(this.active_conversation)
        : "AI Dashboard Assistant";
    },

    messages() {
      return this.active_conversation?.messages || [];
    },

    composer_placeholder() {
      if (this.scope?.level === "property" && this.scope.property_name) {
        return `Ask about ${this.scope.property_name} - water, electricity, solar, battery...`;
      }
      if (this.scope?.level === "portfolio") {
        return "Ask across your portfolio, or pick properties to compare...";
      }
      return "Ask me anything...";
    },
  },

  watch: {
    messages: {
      deep: true,
      handler() {
        this.scroll_to_latest_message();
      },
    },
    active_conversation_id(id) {
      this.save_active_conversation(id);
      this.ensure_active_conversation_messages(id);
      this.scroll_to_latest_message({ settle: true });
    },
    is_open(is_open_state) {
      if (is_open_state) {
        this.handle_assistant_open();
      }
    },
  },

  mounted() {
    this.load_conversations();
  },

  beforeUnmount() {
    this.clear_typewriter_timer();
  },

  methods: {
    ...conversation_methods,
    ...chat_methods,
    ...query_methods,

    close_assistant() {
      this.$emit("close-assistant");
    },

    toggle_fullscreen() {
      this.is_fullscreen = !this.is_fullscreen;
    },

    toggle_history() {
      this.is_history_open = !this.is_history_open;
    },

    async handle_assistant_open() {
      if (this.is_loading_chat_history) {
        this.should_start_new_after_history_load = true;
        return;
      }

      const reload_result = this.retry_load_conversations_if_needed();

      if (reload_result && typeof reload_result.then === "function") {
        this.should_start_new_after_history_load = true;
        await reload_result;
        return;
      }

      this.start_fresh_open_conversation();
    },

    start_fresh_open_conversation() {
      this.should_start_new_after_history_load = false;
      this.start_new_conversation({ reuse_empty_active: true });
      this.scroll_to_latest_message({ settle: true });
    },

    scroll_to_latest_message(options) {
      this.$nextTick(() => {
        this.$refs.chat_messages?.scroll_to_bottom(options);
      });
    },
  },
};
